<span id="modelopen" data-bs-target="#PayorRequirededit" data-bs-toggle="modal"></span>


<div class="modal fade" id="PayorRequirededit" data-bs-backdrop="static">

    <div class="modal-dialog ">
        <div class="modal-content">


            <div class="modal-header">
                <h5 class="modal-title font-header" *ngIf="payoRequiredViewEditdata.isEditPayorRequired == true">
                    UpdatePayor Info</h5>

                <h5 class="modal-title font-header" *ngIf="payoRequiredViewEditdata.isEditPayorRequired == false"> New
                    Payor Info</h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="PayorRequiredForm">
                    <div class="row">

                        <div class="col-lg-3">
                            <label class="label-bold">Payor<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-6">
                            <select [(ngModel)]="PayorRequired.payerId" class="form-control"
                                formControlName="PayorName">
                                <option>
                                </option>

                                <option *ngFor="let val of GroupLst" [value]="val.id">
                                    {{val.name}}
                                </option>

                            </select>
                        </div>

                    </div>

                    &nbsp; &nbsp;
                    <div class="row">
                        <div class="col-lg-3">
                            <label class="label-bold">ID<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-6">
                            <input type="text" class="form-control" formControlName="billingPayerRequiredId"
                                [(ngModel)]="PayorRequired.billingPayerRequiredId">
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <div class="row">
                        <div class="col-lg-3">
                            <label class="label-bold">Start Date<sup class="super-script">&nbsp;*</sup></label>
                        </div>
                        <div class="col-lg-6">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="PayorRequired.startDate"
                                [ngModelOptions]="{standalone: true}" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="newdates($event,'inputchage','start')"
                                (dateChanged)="newdates($event,'datechagned','start')">
                            </my-date-picker>
                        </div>
                    </div>
                    &nbsp; &nbsp;
                    <div class="row">
                        <div class="col-lg-3">
                            <label class="label-bold"> End Date</label>
                        </div>
                        <div class="col-lg-6">
                            <my-date-picker [options]="myDatePickerOptions" [selDate]="PayorRequired.endDate"
                                formControlName="Enddate" placeholder="mm/dd/yyyy"
                                (inputFieldChanged)="newdates($event,'inputchage','end')"
                                (dateChanged)="newdates($event,'datechagned','end')">
                            </my-date-picker>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn blue-btn" style="text-transform:none"
                    *ngIf="payoRequiredViewEditdata.isEditPayorRequired == false "
                    (click)="savePayorRequired(PayorRequired);"
                    [disabled]="!PayorRequiredForm.valid || PayorRequired.startDate == '' || PayorRequired.startDate == null || PayorRequired.startDate == undefined ||disabledsavebutton">
                    Save & Close
                </button>&nbsp;
                <button class="btn blue-btn" style="text-transform:none" (click)="savePayorRequired(PayorRequired);"
                    *ngIf="payoRequiredViewEditdata.isEditPayorRequired == true"
                    [disabled]="!PayorRequiredForm.valid || PayorRequired.startDate == '' || PayorRequired.startDate == null || PayorRequired.startDate == undefined ||disabledsavebutton">
                    Update & Close
                </button>&nbsp;
                <button type="button" class="btn blue-btn" (click)="back()" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>